import { getProvisioningTasks } from "@/api/employee-provisioning-tasks.service";
export const useEmployeeProvisioningTasksSearch = () => {
  const itemTitle = i => i.text;
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (v, searchArgs, cancelToken) => {
      const res = await getProvisioningTasks(
        { text: v, page: "1", count: "10", stage: searchArgs.stage },
        cancelToken
      );
      if (!res?.items) return;
      const items = res.items;
      return items.toSorted((a, b) => itemTitle(a).localeCompare(itemTitle(b)));
    }
  };
};
